import React from 'react'
import { Field } from 'formik';
import AddNewSectionDatePicker from './AddNewSectionDatePicker';
import getNewSpellingForDates from '../../../../functions/getNewSpellingForDates';

class AddNewSectionExpireDate extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            startDate: new Date()
        }

        this.handleChange = this.handleChange.bind(this);
    }
   
    handleChange(date, form, field) {
        const day = getNewSpellingForDates(date)
        const optionObject = {
            expireDay: day
        }
        form.setFieldValue(field.name, optionObject)

        this.setState({
            startDate: date
        })
    }

    render() {
        const today = new Date()

        const {startDate} = this.state
        return <Field today={today} handleChange={this.handleChange} startDate={startDate} component={AddNewSectionDatePicker} name={'options'} className="input-field text-light" />
    }
}

export default AddNewSectionExpireDate